import { defineComponent as B, mergeModels as E, useModel as L, ref as f, computed as $, watch as w, createElementBlock as s, openBlock as i, Fragment as V, createVNode as u, createElementVNode as v, unref as t, withCtx as x, createCommentVNode as d, normalizeClass as p, renderSlot as h, createTextVNode as N, toDisplayString as P, mergeProps as R, createBlock as y, normalizeStyle as z } from "vue";
import n from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/ExpandableSection/expandable-section.js";
import { c_expandable_section_m_truncate__content_LineClamp as T } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_expandable_section_m_truncate__content_LineClamp.js";
import { AngleRightIcon as A } from "../../packages/icons/dist/esm/icons/angle-right-icon.js";
import M from "../Button.vue2.js";
import { useOUIAProps as D } from "../../helpers/ouia.js";
import { createReusableTemplate as H, useElementSize as W } from "@vueuse/core";
const F = ["id", "hidden"], Q = /* @__PURE__ */ B({
  name: "PfExpandableSection",
  inheritAttrs: !1,
  __name: "ExpandableSection",
  props: /* @__PURE__ */ E({
    toggleText: {},
    toggleTextExpanded: {},
    toggleTextCollapsed: {},
    detached: { type: Boolean },
    contentId: {},
    large: { type: Boolean },
    widthLimited: { type: Boolean },
    truncate: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    expanded: { type: Boolean, default: !1 },
    expandedModifiers: {}
  }),
  emits: ["update:expanded"],
  setup(c) {
    const a = c, C = D({ id: a.ouiaId, safe: a.ouiaSafe }), o = L(c, "expanded"), [S, g] = H(), l = f(), { width: b } = W(l), m = f(!0), k = $(() => o.value && a.toggleTextExpanded ? a.toggleTextExpanded : !o.value && a.toggleTextCollapsed ? a.toggleTextCollapsed : a.toggleText);
    w(b, I);
    function I() {
      if (!l.value)
        return;
      const e = a.truncate || parseInt(T.value), r = l.value.scrollHeight / parseInt(getComputedStyle(l.value).lineHeight);
      m.value = r > e;
    }
    return (e, r) => (i(), s(V, null, [
      u(t(S), null, {
        default: x(() => [
          e.detached ? d("", !0) : (i(), s("div", {
            key: 0,
            class: p(`${t(n).expandableSection}__toggle`)
          }, [
            u(M, {
              variant: "link",
              inline: !!e.truncate,
              "aria-controls": e.contentId,
              "aria-expanded": o.value,
              onClick: r[0] || (r[0] = (O) => o.value = !o.value)
            }, {
              default: x(() => [
                e.truncate ? d("", !0) : (i(), s("span", {
                  key: 0,
                  class: p(t(n).expandableSectionToggleIcon)
                }, [
                  u(t(A), { "aria-hidden": "" })
                ], 2)),
                h(e.$slots, "toggle-text", {}, () => [
                  N(P(k.value), 1)
                ])
              ]),
              _: 3
            }, 8, ["inline", "aria-controls", "aria-expanded"])
          ], 2))
        ]),
        _: 3
      }),
      v("div", R({ ...t(C), ...e.$attrs }, {
        class: [t(n).expandableSection, {
          [t(n).modifiers.expanded]: o.value,
          [t(n).modifiers.truncate]: e.truncate,
          [t(n).modifiers.displayLg]: e.large,
          [t(n).modifiers.limitWidth]: e.widthLimited
        }]
      }), [
        e.truncate ? d("", !0) : (i(), y(t(g), { key: 0 })),
        v("div", {
          ref_key: "expandableContentRef",
          ref: l,
          id: e.contentId,
          class: p(t(n).expandableSectionContent),
          hidden: !e.truncate && !o.value,
          role: "region",
          style: z({
            [t(T).name]: e.truncate && e.truncate > 0 ? e.truncate : void 0
          })
        }, [
          h(e.$slots, "default")
        ], 14, F),
        e.truncate && m.value ? (i(), y(t(g), { key: 1 })) : d("", !0)
      ], 16)
    ], 64));
  }
});
export {
  Q as default
};
